import { Component, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DropdownOption } from '../../../dropdown-button/dropdown-button.component';
import { ProfileService } from '@shared/services/api/profile.service';
import { Roles, UserRole } from '@shared/models/types';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-analytics-export-button',
  templateUrl: './analytics-export-button.component.html',
  styleUrl: './analytics-export-button.component.scss'
})
export class AnalyticsExportButtonComponent implements OnInit, OnDestroy {
  @Input() isExporting = false;
  @Input() filters?: Record<string, any[]> | null = null;
  @Output() exportFormat = new EventEmitter<'csv' | 'pdf'>();

  exportOptions: DropdownOption[] = [];
  private userRole: UserRole | null = null;
  private destroy$ = new Subject<void>();

  constructor(private translateService: TranslateService, private profileService: ProfileService) {
    this.loadExportOptions();
    this.translateService.onLangChange.subscribe(() => {
      this.loadExportOptions();
    });
  }

  ngOnInit(): void {
    this.profileService.role$.pipe(takeUntil(this.destroy$)).subscribe((role) => {
      this.userRole = role;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadExportOptions(): void {
    this.exportOptions = [
      {
        label: this.translateService.instant('ANALYTICS.EXPORT.EXPORT_CSV'),
        value: 'csv'
      },
      {
        label: this.translateService.instant('ANALYTICS.EXPORT.EXPORT_PDF'),
        value: 'pdf'
      }
    ];
  }

  get buttonLabel(): string {
    return this.isExporting
      ? this.translateService.instant('ANALYTICS.EXPORT.EXPORTING')
      : this.translateService.instant('ANALYTICS.EXPORT.EXPORT_BUTTON');
  }

  get shouldShowButton(): boolean {
    if (this.userRole === Roles.ADMIN) {
      const hasMachineFilter = (this.filters?.['idMachine']?.length ?? 0) > 0;
      return hasMachineFilter;
    }

    return true;
  }

  onExportOptionSelected(option: DropdownOption): void {
    this.exportFormat.emit(option.value);
  }
}
